/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { map, Observable } from 'rxjs';
import { DialogService } from 'nebula-ui-kit';
import { inject, Injectable } from '@angular/core';
import { SelectDialogComponent } from '../../../select-dialog/select-dialog.component';
import { ArticuloService, ArticuloDto } from './articulos.service';

export interface ArticuloSelect {
  id: number;
  codigo: string;
  nombre: string;
  descripcion?: string;
  idTipoArticulo?: number;
  nombreTipoArticulo?: string;
  idUnidadMedida?: number;
  nombreUnidadMedida?: string;
  precio?: number;
  costo?: number;
  stock?: number;
  status: string;
}

export interface ArticuloFilters {
  tipoArticuloId?: number;
  soloConStock?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ArticuloModalService {
  readonly dialogService = inject(DialogService);
  readonly articuloService = inject(ArticuloService);

  openSelector(
    title: string,
    currentValue?: string,
    filters?: ArticuloFilters,
  ): Observable<ArticuloSelect | null> {
    const loadDataFn = this.createLoadDataFn(filters);

    const dialogRef = this.dialogService.open(SelectDialogComponent, {
      data: {
        title: title,
        columns: this.getColumns(),
        multiSelect: false,
        searchPlaceholder: 'Buscar por código...',
        loadDataFn: loadDataFn,
        itemIdKey: 'id',
        displayKey: 'codigo',
        displayFn: (item: any) => (item ? `${item.codigo} - ${item.nombre}` : ''),
        selectedItems: currentValue ? [{ codigo: currentValue, nombre: currentValue }] : [],
        pageSize: 10,
        pageSizeOptions: [10, 25, 50, 100],
      },
      size: 'lg',
      width: '800px',
    });

    return dialogRef.afterClosed().pipe(
      map((selected: ArticuloSelect[]) => {
        if (selected && selected.length > 0) {
          return selected[0];
        }
        return null;
      }),
    );
  }

  private getColumns() {
    return [
      { key: 'codigo', label: 'Código', sortable: true, width: '25%' },
      { key: 'nombre', label: 'Nombre', sortable: true, width: '50%' },
      { key: 'status', label: 'Estado', sortable: true, width: '25%' },
    ];
  }

  private createLoadDataFn(filters?: ArticuloFilters) {
    return async (params: any): Promise<{ data: ArticuloSelect[]; total: number }> => {
      const page = params.page - 1;
      const size = params.limit || 10;
      const searchTerm = params.search || '';

      try {
        const response = await this.articuloService
          .getArticulosPage(page, size, searchTerm, {
            tipoArticuloId: filters?.tipoArticuloId,
          })
          .toPromise();

        let data = response?.content || [];

        if (filters?.soloConStock && data.length > 0) {
          data = data.filter((a) => (a.stock || 0) > 0);
        }

        return {
          data: data.map((a: ArticuloDto) => this.mapToSelect(a)),
          total: filters?.soloConStock ? data.length : response?.totalElements || 0,
        };
      } catch (error) {
        return { data: [], total: 0 };
      }
    };
  }

  private mapToSelect(articulo: ArticuloDto): ArticuloSelect {
    return {
      id: articulo.id,
      codigo: articulo.codigo,
      nombre: articulo.nombre,
      descripcion: articulo.descripcion,
      idTipoArticulo: articulo.idTipoArticulo,
      nombreTipoArticulo: articulo.nombreTipoArticulo,
      idUnidadMedida: articulo.idUnidadMedida,
      nombreUnidadMedida: articulo.nombreUnidadMedida,
      precio: articulo.precio,
      costo: articulo.costo,
      stock: articulo.stock,
      status: articulo.status,
    };
  }
}
